import request from '@/utils/request3'
import store from '@/store'

const serviceName = store.state.serviceName.wflow

// 授权列表（可按授权对象类型/值过滤）
export function listGrants(params) {
  return request({ url: serviceName + `/wflow/grant/list`, method: 'get', params })
}

// 保存授权（一个授权目标 × 多个授权主体）
export function saveGrants(data) {
  return request({ url: serviceName + `/wflow/grant/save`, method: 'post', data })
}

// 删除授权（按 id 删除单条 或 按目标清空）
export function deleteGrant(data) {
  return request({ url: serviceName + `/wflow/grant/delete`, method: 'post', data })
}

// 可选授权目标（一级分类 / 二级分类 / 已发布流程）
export function grantTargets() {
  return request({ url: serviceName + `/wflow/grant/targets`, method: 'get' })
}

// 保存流程图标（flowId + iconUrl，iconUrl 为空则恢复默认）
export function saveFlowIcon(data) {
  return request({ url: serviceName + `/wflow/grant/icon`, method: 'post', data })
}

// 当前用户组织上下文（部门/中心/角色/是否管理员）
export function orgContext() {
  return request({ url: serviceName + `/wflow/grant/orgContext`, method: 'get' })
}

// 组织树（中心 + 部门，供授权主体选择）
export function grantOrgTree() {
  return request({ url: serviceName + `/wflow/grant/orgTree`, method: 'get' })
}
